var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5613 15.3001C13.0262 15.3001 13.4042 14.9263 13.4042 14.4637V2.54401C13.4042 1.16088 12.2707 0.0361328 10.8768 0.0361328H1.81979C1.35485 0.0361328 0.976907 0.409926 0.976907 0.8725C0.976907 1.33507 1.35485 1.70764 1.81979 1.70764H10.8768C11.3417 1.70764 11.7196 2.08266 11.7196 2.54401V14.4649C11.7184 14.9263 12.0963 15.3001 12.5613 15.3001Z",
    fill: "#A4A4A4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.90237 17.4618H10.8647C12.2652 17.4618 13.4042 16.341 13.4042 14.9628V13.2973C13.4054 12.8363 13.0257 12.4639 12.5585 12.4639C12.0913 12.4639 11.7116 12.8363 11.7116 13.2973V14.9628C11.7116 15.4225 11.3319 15.7962 10.8647 15.7962H7.90237C7.43521 15.7962 7.05546 16.1687 7.05546 16.6296C7.0567 17.0893 7.43521 17.4618 7.90237 17.4618Z",
    fill: "#A4A4A4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.19808 0.0781003L7.20648 1.74716C7.88168 1.9822 8.33557 2.61741 8.33557 3.33014V18.3334C8.33557 19.2522 7.58803 20 6.66895 20C6.48886 20 6.32006 19.975 6.13753 19.9188L1.1279 18.2482C0.453928 18.0144 3.33786e-05 17.3783 3.33786e-05 16.6668V1.66353C3.33786e-05 0.565876 1.07906 -0.264381 2.19808 0.0781003Z",
    fill: "#A4A4A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorIcon);
export default __webpack_public_path__ + "static/media/door-icon.ab083303.svg";
export { ForwardRef as ReactComponent };